export function tableIndex(index = 1, currentPage = 1, pageSize = 10) {
  return index + 1 + (currentPage - 1) * pageSize;
}
